import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "currency", "price", "discount", "realPrice", "s", "currencyColor", "priceColor", "discountColor", "realPriceColor", "responsive", "loading"];
import cn from 'classnames';
import CLASSNAMES_BY_TEXT_TYPE from "./responsiveClassnames";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Price = function Price(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    currency = _ref.currency,
    priceProp = _ref.price,
    discount = _ref.discount,
    realPriceProp = _ref.realPrice,
    s = _ref.s,
    currencyColor = _ref.currencyColor,
    priceColor = _ref.priceColor,
    discountColor = _ref.discountColor,
    realPriceColor = _ref.realPriceColor,
    _ref$responsive = _ref.responsive,
    responsive = _ref$responsive === void 0 ? 'sm' : _ref$responsive,
    loading = _ref.loading,
    priceProps = _objectWithoutProperties(_ref, _excluded);
  var realPrice = typeof realPriceProp === 'string' ? parseFloat(realPriceProp) : realPriceProp;
  var price = typeof priceProp === 'string' ? parseFloat(priceProp) : priceProp;
  var hasRealPrice = !!(realPrice && realPrice > price);
  var currencyFontClassNames = CLASSNAMES_BY_TEXT_TYPE(responsive)[s ? 'currency-s' : 'currency'];
  var priceFontClassNames = CLASSNAMES_BY_TEXT_TYPE(responsive)[s ? 'price-s' : 'price'];
  var discountFontClassNames = CLASSNAMES_BY_TEXT_TYPE(responsive)[s ? 'discount-s' : 'discount'];
  var defaultPriceColorClassNames = discount || hasRealPrice ? 'text-red-main' : 'text-base-main';
  var priceBlurColor = discount || hasRealPrice ? 'text-blur-red-main' : 'text-blur-base-main';
  return /*#__PURE__*/_jsxs("p", _objectSpread(_objectSpread({
    className: className
  }, priceProps), {}, {
    children: [/*#__PURE__*/_jsx("span", {
      className: cn(currencyFontClassNames, currencyColor ? "text-".concat(currencyColor) : defaultPriceColorClassNames, _defineProperty({}, priceBlurColor, loading)),
      children: currency
    }), /*#__PURE__*/_jsx("span", {
      className: cn('ml-4', priceFontClassNames, priceColor ? "text-".concat(priceColor) : defaultPriceColorClassNames, _defineProperty({}, priceBlurColor, loading)),
      children: price.toLocaleString()
    }), hasRealPrice && /*#__PURE__*/_jsxs("span", {
      className: cn('line-through', discountFontClassNames, realPriceColor || discountColor ? "text-".concat(realPriceColor || discountColor) : 'text-base-main', {
        'text-blur-base-main': loading
      }),
      children: [currency, realPrice ? realPrice.toLocaleString() : '']
    }), discount && /*#__PURE__*/_jsx("span", {
      className: cn(discountFontClassNames, discountColor ? "text-".concat(discountColor) : 'text-base-main', {
        'text-blur-base-main': loading
      }),
      style: {
        fontWeight: 'bold',
        textDecoration: 'none'
      },
      children: discount
    })]
  }));
};
export default Price;